var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimePause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E3FB94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5c4.965 0 9 4.035 9 9s-4.035 9-9 9-9-4.035-9-9 4.035-9 9-9zm0 17.199A8.21 8.21 0 0022.199 14 8.21 8.21 0 0014 5.801 8.21 8.21 0 005.801 14 8.21 8.21 0 0014 22.199zm-1.06-4.204h-2.258l-.03-7.743h2.256l.032 7.743zm4.489 0H15.17v-7.74h2.259v7.743-.003z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--pause-54fd58a503cfb9c4cbaf6059508fc049.svg";
export { SvgIconCircleLimePause as Component };